import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-0a02c17e")
const _hoisted_1 = {
  key: 0,
  class: "icon-container"
}
const _hoisted_2 = { style: {"margin-left":"15px"} }
const _hoisted_3 = {
  key: 0,
  class: "icon-container"
}
const _hoisted_4 = { style: {"margin-left":"15px"} }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_SubMenu = _resolveComponent("SubMenu", true)!
  const _component_el_submenu = _resolveComponent("el-submenu")!

  return (_ctx.submenu?.child < 1)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (_ctx.submenu.visible)
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 0,
              class: _normalizeClass({ 'collapse-item': _ctx.menu_isCollapse }),
              index: _ctx.index,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openUrl(_ctx.submenu)))
            }, {
              title: _withCtx(() => [
                (_ctx.submenu.icon != '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      _createElementVNode("i", {
                        style: _normalizeStyle({ color: _ctx.submenu.bgColor }),
                        class: _normalizeClass(_ctx.submenu.icon)
                      }, null, 6)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.submenu.title), 1)
              ]),
              _: 1
            }, 8, ["class", "index"]))
          : _createCommentVNode("", true)
      ], 64))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        (_ctx.submenu.visible)
          ? (_openBlock(), _createBlock(_component_el_submenu, {
              key: 0,
              class: _normalizeClass({ 'collapse-item': _ctx.menu_isCollapse }),
              "popper-class": "cus-menuitem",
              index: _ctx.index,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openUrl(_ctx.submenu)))
            }, {
              title: _withCtx(() => [
                (_ctx.submenu.icon != '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createElementVNode("i", {
                        style: _normalizeStyle({ color: _ctx.submenu.bgColor }),
                        class: _normalizeClass(_ctx.submenu.icon)
                      }, null, 6)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.submenu.title), 1)
              ]),
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.submenu.child, (item, id) => {
                  return (_openBlock(), _createBlock(_component_SubMenu, {
                    key: id,
                    submenu: item,
                    index: item.key
                  }, null, 8, ["submenu", "index"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["class", "index"]))
          : _createCommentVNode("", true)
      ], 64))
}